import { createClient as createSupabaseClient, SupabaseClient } from '@supabase/supabase-js'
import type { Database } from '@/integrations/supabase/types'

// Singleton instance
let supabaseInstance: SupabaseClient<Database> | null = null

export function createClient() {
  // Return existing instance if already created
  if (supabaseInstance) {
    return supabaseInstance
  }

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

  // Validate environment variables (sanitized)
  if (!supabaseUrl || !supabaseAnonKey) {
    console.error('❌ [SUPABASE] Missing required environment variables')
    throw new Error(
      'Missing Supabase configuration. Please check your environment setup.'
    )
  }

  // Validate URL format (sanitized)
  try {
    new URL(supabaseUrl)
  } catch (error) {
    console.error('❌ [SUPABASE] Invalid Supabase URL format')
    throw new Error(
      'Invalid Supabase URL configuration. Please check your environment setup.'
    )
  }

  // Create new instance with optimized configuration
  supabaseInstance = createSupabaseClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: window.localStorage,
    },
    realtime: {
      params: {
        eventsPerSecond: 10,
      },
    },
  })

  return supabaseInstance
}
